import{d as r}from"./chunk-LN5BWZTJ.js";import{q as i}from"./chunk-XWP3O7NO.js";import{b as o}from"./chunk-KCM44TS7.js";import{m as t}from"./chunk-HBP5N4FR.js";t();i();function p(e){return r(n=>o(n,e))}export{p as a};
//# sourceMappingURL=chunk-IH7PVMIO.js.map
